import * as React from 'react';
import './index.scss';

export interface PlaceBadgetProps extends React.HTMLAttributes<HTMLDivElement> {
  fillColor: string;
  collegeName: string;
}

export const PlaceBadget: React.FC<PlaceBadgetProps> = ({
  fillColor,
  collegeName,
  className,
}) => (
  <div
    className={['PlaceBadget', className].join(' ')}
    style={{ backgroundColor: fillColor }}
  >
    <span>{collegeName}</span>
  </div>
);
